/**
 * BrandMark — single source of truth for the Torahya logo.
 *
 * Always use this component instead of <img>-ing the logo directly so
 * we can swap the asset / add motion / wrap it in a link from one place.
 *
 * Usage:
 *   <BrandMark size={48} />              // square logo, 48×48
 *   <BrandMark size={32} withWordmark /> // logo + Hebrew/Latin wordmark
 */
export default function BrandMark({
  size = 40,
  withWordmark = false,
  wordmarkLang = "both", // "he" | "en" | "both"
  className = "",
  ...rest
}) {
  // Pick the closest sized asset to keep network payload small.
  const src =
    size <= 64 ? "/brand/icon-64.png"
    : size <= 96 ? "/brand/icon-96.png"
    : size <= 192 ? "/brand/icon-192.png"
    : size <= 256 ? "/brand/logo-256.png"
    : "/brand/logo-512.png";

  if (!withWordmark) {
    return (
      <img
        src={src}
        width={size}
        height={size}
        alt='תוריא · Torahya'
        className={`block select-none ${className}`}
        draggable={false}
        loading="eager"
        decoding="async"
        {...rest}
      />
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="brand-mark"
      {...rest}
    >
      <img
        src={src}
        width={size}
        height={size}
        alt='תוריא'
        className="block select-none rounded-md"
        draggable={false}
        loading="eager"
        decoding="async"
      />
      <span className="flex flex-col leading-tight" dir="rtl">
        {(wordmarkLang === "he" || wordmarkLang === "both") && (
          <span className="font-heading text-base text-foreground">תוריא</span>
        )}
        {(wordmarkLang === "en" || wordmarkLang === "both") && (
          <span className="font-latin italic text-[11px] tracking-wider text-gold/80">
            TORAHYA
          </span>
        )}
      </span>
    </span>
  );
}
